import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Subscribe from '../components/Subscribe';

const Home = () => {
  useEffect(() => {
    if (sessionStorage.getItem('scroll_to_about') === 'true') {
      sessionStorage.removeItem('scroll_to_about');
      setTimeout(() => {
        const element = document.getElementById('about-section');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 350);
    }
  }, []);

  return (
    <>
      <Hero />
      <div id="about-section">
        <AboutUs />
      </div>
      <Subscribe />
    </>
  );
};

export default Home; 